export default {
      id: "icon-boexpertfull-usage",
      viewBox: "0 0 55 55",
      url: __webpack_public_path__ + "icons.svg#icon-boexpertfull",
      toString: function () {
        return this.url;
      }
    }